import React from 'react'
import './fieldset.scss';

const FieldsetUI = (props) => {
  return (
    <fieldset id={props.id} className={`fieldsetUI ${props.className}`} style={props.style}>
        <legend className="legendUI" >{props.label}

         <span style={{ color: 'red' ,marginLeft:'10px'}}>{props.label2}</span>

        </legend>

        {props.children}
    </fieldset>
  )
}

export default FieldsetUI